import { apiPost, apiGet, apiDelete, apiPut, apiDCHGet, apiDCHPost } from '../utils/api'
import { apiMSDispatchURL } from '../utils/constants'

const uri = apiMSDispatchURL || 'https://api.stage.blaze.me/ms/dispatch'

export const getWorkerByProviderAPI = ({ provider, companyId, shopId }) => {
  return apiDCHGet(
    uri + `/api/v1/employee/provider/${provider}?companyId=${companyId}&shopId=${shopId}`,
  )
}

export const getDCHEmployeesByCompanyAPI = (companyId) => {
  return apiDCHGet(uri + `/api/v1/employee/internal/${companyId}`)
}

export const getDCHEmployeesByCompanyIdAndShopIdAPI = (request) => {
  return apiDCHPost(uri + `/api/v1/employee/internal/byShop`, request)
}

export const createWorkerOnDispatchAPI = ({ driver, provider }) => {
  return apiDCHPost(uri + `/api/v1/employee/create?providerStr=${provider}`, driver)
}

export const createInternalWorkerOnDispatchAPI = ({ request }) => {
  return apiDCHPost(uri + `/api/v1/employee/internal/create`, request)
}

export const syncWorkerOnDispatchAPI = (request) => {
  return apiDCHPost(uri + `/api/v1/employee/sync/worker`, request)
}

export const removeWorkerOnDispatchAPI = ({ request, provider }) => {
  return apiDCHPost(uri + `/api/v1/employee/remove/worker/${request}?providerStr=${provider}`)
}

export const deleteEmployeeOnDispatchAPI = ({ request, provider }) => {
  return apiDCHPost(uri + `/api/v1/employee/delete?providerStr=${provider}`, request)
}

export const getDriversByAssignedShopAPI = (shopId) => {
  return apiGet(`mgmt/employees/dispatch/drivers?shopId=${shopId}`)
}

export const getDCHSettingsByCompanyIdAPI = (companyId) => {
  return apiDCHGet(uri + `/api/v1/settings/${companyId}`)
}

export const getDCHSettingsByCompanyIdAndShopIdsAPI = (request) => {
  return apiDCHPost(uri + `/api/v1/settings/search`, request)
}

export const createDCHSettingsAPI = ({ request, provider }) => {
  return apiDCHPost(uri + `/api/v1/settings/create?providerStr=${provider}`, request)
}

export const updateDCHSettingsAPI = ({ request, provider }) => {
  return apiDCHPost(uri + `/api/v1/settings/update?providerStr=${provider}`, request)
}

export const deleteDCHSettingsAPI = ({ request }) => {
  return apiDCHPost(uri + `/api/v1/settings/delete`, request)
}

export const getDCHCredentialByShopIdAPI = ({ companyId, shopId, provider }) => {
  return apiDCHGet(
    uri +
      `/api/v1/credential/findActiveByShop?providerStr=${provider}&companyId=${companyId}&shopId=${shopId}`,
  )
}

export const updateDCHCredentialsAPI = ({ request, provider }) => {
  return apiDCHPost(uri + `/api/v1/credential/activate?providerStr=${provider}`, request)
}

export const createDCHCredentialsAPI = ({ provider, request }) => {
  return apiDCHPost(uri + `/api/v1/credential/create?providerStr=${provider}`, request)
}

export const checkDCHApiKeyAPI = ({ provider, request }) => {
  return apiDCHPost(uri + `/api/v1/credential/check?providerStr=${provider}`, request)
}

export const getDCHRenewTokenAPI = ({ provider, request }) => {
  return apiDCHPost(uri + `/api/v1/credential/renew?providerStr=${provider}`, request)
}



// WEBPACK FOOTER //
// ./src/api/dispatch.js